import React from 'react';
import { Toast } from 'react-bootstrap';
import styles from './alert.module.scss';

const Alert = ({options}) => {
  const {msg, isVisible, type, onClose} = options;

  return (
    <Toast
      className={styles['toast-container']}
      aria-label={msg}
      onClose={onClose}
      show={isVisible}
      delay={3000} autohide>
      <Toast.Header className={`${styles['toast-header']} ${styles[type]}`}>
        {msg}
      </Toast.Header>
    </Toast>
  );
}

export default Alert;
